export default "__VITE_ASSET__Cai6e68E__"